import {createApp} from 'vue';
import {createRouter, createWebHistory} from 'vue-router';

/* Pinia */
import {createPinia} from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./assets/js/color-modes";

/* Font Awesome */
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'

import App from './App.vue';

import MainPage from "@/components/MainPage.vue";
import NotFoundPage from "@/components/NotFoundPage.vue";
import { useAuthStore } from "@/stores/auth";

library.add(fas, far)

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {path: '/', component: MainPage},
        {path: '/:pathMatch(.*)*', component: NotFoundPage}
    ]
})

router.beforeEach((to, from, next) => {
    // Redirect base /admin or /admin/ directly to /admin/overview
    if (to.path === '/admin' || to.path === '/admin/') {
        return next('/admin/overview')
    }

    if (to.meta.requiresAdmin) {
        const authStore = useAuthStore()
        const user = authStore.user

        const isAdmin = user && (
            (Array.isArray(user.roles) && user.roles.some(r => r.role_id === 1 || r.name === 'admin'))
        )

        if (!user || !isAdmin) {
            return next('/404')
        }
    }
    next()
})

const app = createApp(App);
const pinia = createPinia()

pinia.use(piniaPluginPersistedstate)

app.component('font-awesome-icon', FontAwesomeIcon)

app.use(router);
app.use(pinia);

app.mount('#app');
